import { Link } from "react-router-dom";
import { Clock, Mail, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CHANNELS = [
  {
    icon: Mail,
    title: "Email Us",
    line1: "everydayessentials@gmail.com",
    line2: "We reply within 24 hours",
    href: "mailto:everydayessentials@gmail.com",
    testid: "contact-email",
  },
  {
    icon: MessageCircle,
    title: "WhatsApp",
    line1: "+91 98765 43210",
    line2: "Chat with our support team",
    href: "https://wa.me/919876543210",
    testid: "contact-whatsapp",
  },
  {
    icon: Clock,
    title: "Support Hours",
    line1: "Monday – Saturday",
    line2: "10:00 AM – 7:00 PM IST",
    href: null,
    testid: "contact-hours",
  },
];

export default function ContactPage() {
  return (
    <main data-testid="contact-page" className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-24">
      <Reveal className="text-center">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-neutral-400">We're Here to Help</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl lg:text-5xl">
          Contact <span className="font-serif font-medium italic">Us</span>
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-neutral-500 sm:text-base">
          Questions about an order, a product, or a return? Reach out — a real human will get back to you.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {CHANNELS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08}>
            {c.href ? (
              <a
                href={c.href}
                data-testid={c.testid}
                className="block h-full rounded-2xl border border-neutral-200 bg-white p-7 text-center transition-all duration-300 hover:border-neutral-900 hover:shadow-sm"
              >
                <c.icon size={22} strokeWidth={1.6} className="mx-auto text-neutral-900" />
                <h2 className="mt-4 font-heading text-base font-bold">{c.title}</h2>
                <p className="mt-2 text-sm font-medium text-neutral-700">{c.line1}</p>
                <p className="mt-1 text-xs text-neutral-400">{c.line2}</p>
              </a>
            ) : (
              <div data-testid={c.testid} className="h-full rounded-2xl border border-neutral-200 bg-white p-7 text-center">
                <c.icon size={22} strokeWidth={1.6} className="mx-auto text-neutral-900" />
                <h2 className="mt-4 font-heading text-base font-bold">{c.title}</h2>
                <p className="mt-2 text-sm font-medium text-neutral-700">{c.line1}</p>
                <p className="mt-1 text-xs text-neutral-400">{c.line2}</p>
              </div>
            )}
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-12 text-center">
        <p className="text-sm text-neutral-500">
          Looking for shipping, returns, or tracking info?{" "}
          <Link to="/#faq" className="font-semibold text-neutral-900 underline underline-offset-4" data-testid="contact-faq-link">
            Read our FAQs
          </Link>
        </p>
      </Reveal>
    </main>
  );
}
